/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation LCRRoutePlanDeleteManyMutation($routePlanIds: [ID!] !) {
    LCRRoutePlanDeleteMany(routePlanIds: $routePlanIds){
      message
      status
    }
  }
`
